import React, { useContext, useEffect, useState } from "react";
import { exportSymptoms, getSymptoms } from "../../apis/symptom";
import { Symptom } from "../../interfaces/Symptom";
import Modal from "../../components/Modal";
import AddSymptom from "./AddSymptom";
import { LanguageContext } from "../../providers/LanguageProvider";
import { format } from "date-fns";
import CommonPagination from "../../components/CommanPagination";

const SymptomList = () => {
  const [symptoms, setSymptoms] = useState<Array<Symptom>>([
    {
      name: "",
    },
  ]);
  const [editableId, setEditableId] = useState(null);
  const [isSymptomModalOpen, setSymptomModalVisibility] =
    useState<boolean>(false);
  const [meta, setMeta] = useState<any>();
  const { translate: t } = useContext(LanguageContext);

  useEffect(() => {
    fetchSymptoms({ per_page: 10 });
  }, []);

  const fetchSymptoms = (params: {}) =>
    getSymptoms(params).then((res: any) => {
      setSymptoms(res.data.data);
      setMeta(res.data.meta);
    });

  const editSymptom = (symptomId: any) => {
    if (symptomId) {
      setEditableId(symptomId);
      setSymptomModalVisibility(true);
    }
  };

  const handleCloseModal = () => {
    setEditableId(null);
    setSymptomModalVisibility(false);
    fetchSymptoms({});
  };
  // const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   fetchSymptoms({ page, per_page: pageSize });
  // };
  const onPaginationChange = (page: number, pageSize?: number) => {
  fetchSymptoms({ page, per_page: pageSize || 10 }); 
};

  const exportSymptomsList = (params: any) => {
    exportSymptoms(params).then((res: any) => {
      downloadFile(res.data);
    });
  };

  const downloadFile = (data: any) => {
    const blob = new Blob([data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    const today = format(new Date(), "dd_MM_yyyy_hh_mm");
    downloadLink.download = "symptoms-" + today + ".xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex lg:hidden">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {t("symptoms")}
          </h1>
        </div>
        <div className="flex flex-row-reverse w-full">
          <div>
            <button
              type="button"
              onClick={() => setSymptomModalVisibility(true)}
              className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
            </button>
          </div>
          <div>
            <button
              type="button"
              onClick={() => exportSymptomsList({})}
              className="block px-3 py-2 mx-2 text-sm font-semibold text-center text-white capitalize rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="hidden sm:items-center lg:flex">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {t("symptoms")}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {t("symptom_description")}
          </p>
        </div>
        <div className="flex mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            onClick={() => setSymptomModalVisibility(true)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {t("add_symptom")}
          </button>

          <button
            type="button"
            onClick={() => exportSymptomsList({})}
            className="block px-3 py-2 ml-2 text-sm font-semibold text-center text-white capitalize rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {t("export")}
          </button>
        </div>
      </div>
      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 capitalize"
                    >
                      {t("name")}
                    </th>

                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-6 text-left capitalize"
                    >
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {symptoms && symptoms.length > 0 ? (
                    symptoms?.map((symptom,index) => (
                      <tr key={symptom.id || index}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                          {symptom.name}
                        </td>

                        <td className="relative py-4 pl-3 pr-4 text-sm font-medium text-left whitespace-nowrap sm:pr-6">
                          <button
                            onClick={() => editSymptom(symptom.id)}
                            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            {t("edit")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={2}
                        className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        {t("Record Not Found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* <div className="flex justify-end pt-5">
              <Pagination
                defaultCurrent={1}
                defaultPageSize={10}
                total={meta?.total}
                onChange={onPaginationChange}
              />
            </div> */}
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>
      {isSymptomModalOpen && (
        <Modal
          title={editableId ? "Update Symptom" : "Add Symptom"}
          onClose={() => handleCloseModal()}
          modalContent={
            <AddSymptom
              editableId={editableId}
              closeModal={() => handleCloseModal()}
            />
          }
        />
      )}
    </div>
  );
};
export default SymptomList;
